import {
  removeEmptyValuesFromObject,
  transformToSnakeCase,
} from '@carboncopyco/utils';
import queryString from 'query-string';

// for serializing query params in the form of "foo=bar&foo=baz"

export function serializeMultiParams(
  params: Record<string, string | string[] | number[]>
) {
  const queryParams = removeEmptyValuesFromObject(params);
  return queryString.stringify(transformToSnakeCase(queryParams));
}
